<div class="flex-row">

  <mat-card class="explore mat-elevation-z6">

    <mat-card-title>
      Explore the scope of modelling!
    </mat-card-title>

    <mat-card-content>
      <p>ExploSYS develops cutting edge models capable of realistically
        assessing problems in epidemiology and public health. To assist
        pharmaceutical and public health decision makers on a high
        scientific level is our target.
      </p>

      <p><span class="run-in">Working in this field since 2005,</span>
        we are widely acknowledged experts for the mathematical
        and statistical modelling of biological systems, notably
        transmissible diseases.
      </p>

      <p><span class="run-in">We offer a long standing expertise</span>
        for dynamic modelling alternative health policy and intervention
        scenarios. Acting 'what-if' scenarios to the end results in
        reliable planning, lower costs and higher margins of safety.
      </p>

      <p><span class="run-in">Our models are successfully applied</span>
        e.g. for pandemic preparedness planning, for economic evaluation
        of vaccination policies or the assessment of treatment alternatives.
      </p>

      <p><span class="run-in">Innovative and custom-fit models,</span>
        interactive and high performance simulators, visualisation,
        data mining and reporting, mobile and web applications are
        the services we have to offer.
      </p>
    </mat-card-content>

    <mat-card-title>
      Let's meet your challenges!
    </mat-card-title>

  </mat-card>

  <!-- <mat-card>another card</mat-card> -->

</div>




